import AclName from '../acl/AclName';
import model from '../models-v2/bookkeeping/work-parameters';

export default [
  {
    path: '/admin/templates/work-parameters',
    name: 'admin-work-parameters',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      acl: AclName.SettingsPageTemplatesKhTemplatesList,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Parametry pracy', url: '/admin/templates/work-parameters' },
      ],
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/admin/templates/work-parameters/add',
    name: 'admin-work-parameters-add',
    component: () => import('../views/pages/work-parameters/WorkParametersForm.vue'),
    meta: {
      acl: AclName.SettingsPageTemplatesKhTemplatesEdit,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Parametry pracy', url: '/admin/templates/work-parameters' },
        { title: 'Dodawanie', url: '' },
      ],
      rule: 'editor',
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
    }
  },
  {
    path: '/admin/templates/work-parameters/edit/:id',
    name: 'admin-work-parameters-edit',
    component: () => import('../views/pages/work-parameters/WorkParametersForm.vue'),
    meta: {
      acl: AclName.SettingsPageTemplatesKhTemplatesEdit,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Parametry pracy', url: '/admin/templates/work-parameters' },
        { title: 'Edycja', url: '' },
      ],
      rule: 'editor',
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
  },
];
